import type { FC, PropsWithChildren } from 'react'
import type { LocationResult } from '@alexanderathoodly/data-models'
import { Helmet } from 'react-helmet-async'
import { getLocalBusinessObj } from '~/structured_data/localbusiness'
import { useQuery } from 'react-query'
import {
	getProviderQuery,
	getTestimonialsQuery,
	servicesQuery,
} from './queries'
import { SERVICES } from './services'
import { useTranslation } from 'react-i18next'

export const FlexOfficeLocationHelmet: FC<
	PropsWithChildren<{
		location: LocationResult
	}>
> = ({ location, children }) => {
	const { i18n, t } = useTranslation()
	const { data: provider } = useQuery(getProviderQuery(location.provider))
	const { data: testimonials } = useQuery(getTestimonialsQuery(location.id))
	const { data: services } = useQuery(servicesQuery)
	const isLoaded = !(
		provider == undefined ||
		testimonials == undefined ||
		services == undefined
	)
	return (
		<Helmet>
			{children}
			<script type="application/ld+json">
				{isLoaded
					? JSON.stringify(
							getLocalBusinessObj(
								location.name,
								provider.name,
								i18n.language != 'en'
									? location.short_description
									: location.short_description_en,
								location.address,
								'',
								location.url,
								location.highlights.map((highlight) => t(highlight)).toString(),
								location.images[0] || '',
								services
									.filter((s) => location.services.indexOf(s.id) > -1)
									.map((s) => SERVICES[s.name]?.name || ''),
								testimonials.map((t) => {
									return { review: t.content, author: t.person_name }
								})
							)
					  )
					: ''}
			</script>
		</Helmet>
	)
}
